import { render, staticRenderFns } from "./WorkflowUrgencyAdd.vue?vue&type=template&id=d77baa60&scoped=true"
import script from "./WorkflowUrgencyAdd.vue?vue&type=script&lang=js"
export * from "./WorkflowUrgencyAdd.vue?vue&type=script&lang=js"
import style0 from "./WorkflowUrgencyAdd.vue?vue&type=style&index=0&id=d77baa60&prod&lang=css"
import style1 from "./WorkflowUrgencyAdd.vue?vue&type=style&index=1&id=d77baa60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d77baa60",
  null
  
)

export default component.exports